import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignupRootComponent } from '@app/modules/signup-new/components/signup-root/signup-root.component';
import { SignupWelcomeComponent } from '@app/modules/signup-new/components/signup-welcome/signup-welcome.component';
import { SignupWizardComponent } from '@app/modules/signup-new/components/signup-wizard/signup-wizard.component';
import { SignupChannelsPageComponent } from '@app/modules/signup-new/pages/signup-channels-page/signup-channels-page.component';
import { SignupDonePageComponent } from '@app/modules/signup-new/pages/signup-done-page/signup-done-page.component';
import { SignupEmailPageComponent } from '@app/modules/signup-new/pages/signup-email-page/signup-email-page.component';
import { SignupMobilePageComponent } from '@app/modules/signup-new/pages/signup-mobile-page/signup-mobile-page.component';
import { SignupNamePageComponent } from '@app/modules/signup-new/pages/signup-name-page/signup-name-page.component';
import { SignupOnboardingPageComponent } from '@app/modules/signup-new/pages/signup-onboarding-page/signup-onboarding-page.component';
import { SignupPasswordPageComponent } from '@app/modules/signup-new/pages/signup-password-page/signup-password-page.component';
import { SignupPropertiesPageComponent } from '@app/modules/signup-new/pages/signup-properties-page/signup-properties-page.component';
import { SignupRestrictedPageComponent } from '@app/modules/signup-new/pages/signup-restricted-page/signup-restricted-page.component';
import { SignupReturningPageComponent } from '@app/modules/signup-new/pages/signup-returning-page/signup-returning-page.component';
import { SignupValidateMobilePageComponent } from '@app/modules/signup-new/pages/signup-validate-mobile-page/signup-validate-mobile-page.component';
import { SignupWithAirbnbCallbackComponent } from '@app/modules/signup-new/pages/signup-with-airbnb-callback/signup-with-airbnb-callback.component';
import { SignupWithAirbnbPageComponent } from '@app/modules/signup-new/pages/signup-with-airbnb-page/signup-with-airbnb-page.component';
import { RedirectIfLoggedInGuard } from '@app/shared/guards/redirect-if-logged-in.guard';

const routes: Routes = [
  {
    path: '',
    component: SignupRootComponent,
    canActivate: [RedirectIfLoggedInGuard],
    children: [
      {
        path: '',
        component: SignupWelcomeComponent,
        children: [
          {
            path: '',
            component: SignupEmailPageComponent,
          },
          {
            path: 'returning',
            component: SignupReturningPageComponent,
          },
          {
            path: 'restricted',
            component: SignupRestrictedPageComponent,
          },
          {
            path: 'airbnb',
            component: SignupWithAirbnbPageComponent,
          },
          {
            path: 'airbnb-callback',
            component: SignupWithAirbnbCallbackComponent,
          },
        ],
      },
      {
        path: '',
        component: SignupWizardComponent,
        children: [
          {
            path: 'name',
            component: SignupNamePageComponent,
          },
          {
            path: 'mobile',
            component: SignupMobilePageComponent,
          },
          {
            path: 'validate-mobile',
            component: SignupValidateMobilePageComponent,
          },
          {
            path: 'properties',
            component: SignupPropertiesPageComponent,
          },
          {
            path: 'channels',
            component: SignupChannelsPageComponent,
          },
          {
            path: 'password',
            component: SignupPasswordPageComponent,
          },
          {
            path: 'onboarding',
            component: SignupOnboardingPageComponent,
          },
          {
            path: 'done',
            component: SignupDonePageComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({ imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class SignupRoutingModule {}
